import { apiGet, unwrapList } from './helpers'

const PATH = 'inv/stock'

export default {
  list: params => apiGet(PATH, params).then(unwrapList),
}
